import React, { useEffect } from "react";

type props = {
  onResponse: any;
  scope: any;
  fields: any;
  appid: any;
  onRender: any;
};

export const FacebookAuth = (props: props): React.JSX.Element => {
  const { onResponse, fields, scope, appid, onRender } = props;

  useEffect(() => {
        const channel = new BroadcastChannel("meta-auth-channel");
        channel.onmessage = (event) => {
          const accessToken: any = event.data.accessToken;
          onResponse({ accessToken: accessToken ,fields:fields});
        };
        return () => channel.close();
      }, []);
  
    const handleFacebookLogin = (): void => {
      const state = encodeURIComponent(`${window.origin}/meta`);
      const appId = appid; // Replace with your Facebook App ID
      const redirectUri = `${process.env.REACT_APP_SOCIAL_CALLBACK}/metacallback`; // Must match your app settings
      const scopes = scope; // Permissions you need
      const width = 599;
      const height = 599;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`;
      const facebookAuthUrl = `${process.env.REACT_APP_FB_LOGIN_URL}?client_id=${appId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${scopes}&state=${state}&response_type=token`;
      window.open(facebookAuthUrl, "childwindow", features);
    };
  

  return (
    <>{onRender({ onClick: handleFacebookLogin })}</>
  );
};
